import { render, staticRenderFns } from "./MdMaskEditCN.vue?vue&type=template&id=12ca62a7&"
import script from "./MdMaskEditCN.vue?vue&type=script&lang=js&"
export * from "./MdMaskEditCN.vue?vue&type=script&lang=js&"
import style0 from "./MdMaskEditCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports